import { apiClient } from '@/core/apiClient';

export type AdminBanner = {
  id: string;
  title?: string | null;
  link_url?: string | null;
  desktop_image_path: string;
  mobile_image_path: string;
  is_active: boolean;
  sort_order: number;
};

export const bannersApi = {
  listAdmin: async (): Promise<AdminBanner[]> => {
    const res = await apiClient.get('/admin/banners');
    return Array.isArray(res.data?.items) ? res.data.items : [];
  },

  create: async (payload: FormData) => {
    const res = await apiClient.post('/admin/banners', payload, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return res.data;
  },

  update: async (id: string, payload: FormData | { title?: string; link_url?: string; is_active?: boolean }) => {
    if (payload instanceof FormData) {
      const res = await apiClient.patch(`/admin/banners/${id}`, payload, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      return res.data;
    }
    const res = await apiClient.patch(`/admin/banners/${id}`, payload);
    return res.data;
  },

  remove: async (id: string) => {
    const res = await apiClient.delete(`/admin/banners/${id}`);
    return res.data;
  },

  reorder: async (orderedIds: string[]) => {
    const res = await apiClient.post('/admin/banners/reorder', { orderedIds });
    return res.data;
  },
};
